import { FC } from 'react';
import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { FormattedMessage } from 'dibs-react-intl';

export const PdpSharedDesignYourOwnMessage: FC = () => {
    return (
        <div className={classnames(dibsCss.sassyFontBodySmall, dibsCss.mtXsmall)}>
            <FormattedMessage
                id="PdpSharedDesignYourOwnMessage.message"
                defaultMessage="Design Your Own: Collaborate with the jeweler to create a one-of-a-kind piece."
            />
        </div>
    );
};
